// Tomahawk shell — sidebar nav for the territorial-acquisition core.
// Nav reduced to the 7 strategic items (spec §3). Branding repositioned
// away from "marketing/CRM" toward "inteligência territorial de aquisição".
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { clearSession } from "../lib/api";

const NAV = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/personas", label: "Personas" },
  { to: "/locais", label: "Locais" },
  { to: "/zonas", label: "Zonas de Intenção" },
  { to: "/campanhas", label: "Campanhas" },
  { to: "/performance", label: "Performance" },
  { to: "/configuracoes", label: "Configurações" },
];

export default function Layout({ children }) {
  const navigate = useNavigate();
  const name = localStorage.getItem("tmhk_name") || "Conta";

  return (
    <div className="min-h-screen flex bg-neutral-950 text-neutral-100">
      <aside className="w-64 shrink-0 border-r border-neutral-800 flex flex-col">
        <div className="px-5 py-6 border-b border-neutral-800">
          <div className="text-xl font-bold tracking-tight">
            Tomahawk<span className="text-red-600">.</span>
          </div>
          <p className="mt-1 text-[11px] leading-snug text-neutral-500">
            Inteligência territorial de aquisição
          </p>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                "block rounded-md px-3 py-2 text-sm transition-colors " +
                (isActive
                  ? "bg-red-600/15 text-red-400 font-medium"
                  : "text-neutral-400 hover:bg-neutral-800/60 hover:text-neutral-100")
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-3 py-4 border-t border-neutral-800">
          <div className="px-3 text-xs text-neutral-500 mb-2 truncate">{name}</div>
          <button
            onClick={() => {
              clearSession();
              navigate("/login");
            }}
            className="w-full rounded-md px-3 py-2 text-sm text-neutral-400 hover:bg-neutral-800/60 hover:text-neutral-100 text-left"
          >
            Sair
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 overflow-x-hidden">
        <div className="max-w-6xl mx-auto px-6 py-8">{children}</div>
      </main>
    </div>
  );
}
